<div class="token-reveal">
  <h3 id="token-reveal-title">{{ "admin.api-tokens.reveal.title" | translate }}</h3>

  <nz-alert
    nzType="warning"
    nzShowIcon
    [nzMessage]="'admin.api-tokens.reveal.warning' | translate"
    [nzDescription]="'admin.api-tokens.reveal.warning.description' | translate"
  ></nz-alert>

  <div class="token-reveal__value">
    <input nz-input readonly aria-labelledby="token-reveal-title" [value]="modalData.token" (click)="copyToken()" />
    <button nz-button nzType="default" (click)="copyToken()">
      <span nz-icon nzType="copy" nzTheme="outline"></span>
      {{ "admin.api-tokens.reveal.copy.btn" | translate }}
    </button>
  </div>

  <div class="token-reveal__actions">
    <button nz-button nzType="primary" (click)="onClose()">
      {{ "admin.api-tokens.reveal.done.btn" | translate }}
    </button>
  </div>
</div>
